import { apiGet } from "../baseApi";
import { setTag } from "service/mapper";

export const getById = async (id) => {
  try {
    const response = await apiGet("_tag", {}, id);
    return { ...response, data: setTag(response.data) };
  } catch (error) {
    return Promise.reject(error);
  }
};
